import React from 'react';
import { useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbNavigation = () => {
  const location = useLocation();

  // Route configuration for breadcrumbs
  const routeConfig = {
    '/dashboard': { label: 'Dashboard', parent: null },
    '/product-catalog-management': { label: 'Productos', parent: '/dashboard' },
    '/quotation-management': { label: 'Presupuestos', parent: '/dashboard' },
    '/invoice-management': { label: 'Facturas', parent: '/dashboard' },
    '/inventory-control': { label: 'Inventario', parent: '/dashboard' },
  };

  const generateBreadcrumbs = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const breadcrumbs = [];

    // Always start with Dashboard if not already there
    if (location.pathname !== '/dashboard') {
      breadcrumbs.push({
        label: 'Dashboard',
        path: '/dashboard',
        isActive: false
      });
    }

    // Add current page
    const currentRoute = routeConfig[location.pathname];
    if (currentRoute) {
      breadcrumbs.push({
        label: currentRoute.label,
        path: location.pathname,
        isActive: true
      });
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  // Don't show breadcrumbs on login page or if only one item
  if (location.pathname === '/login' || breadcrumbs.length <= 1) {
    return null;
  }

  const handleNavigation = (path) => {
    if (path !== location.pathname) {
      window.location.href = path;
    }
  };

  return (
    <nav className="flex items-center space-x-2 text-sm mb-6" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {breadcrumbs.map((crumb, index) => (
          <li key={crumb.path} className="flex items-center">
            {index > 0 && (
              <Icon 
                name="ChevronRight" 
                size={16} 
                className="text-text-muted mx-2" 
              />
            )}
            
            {crumb.isActive ? (
              <span className="text-text-primary font-body-medium">
                {crumb.label}
              </span>
            ) : (
              <button
                onClick={() => handleNavigation(crumb.path)}
                className="text-text-secondary hover:text-primary transition-micro font-body-normal"
              >
                {crumb.label}
              </button>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default BreadcrumbNavigation;